import type { WinStreakRoadMapData } from '../types';
import { WinStreakStandardDecorationsLayout } from '../../../../layouts/winStreak/WinStreakStandardDecorationsLayout';
import type { AnyModel } from '../../../libs/layouts/populateLayouts/types/models';
import { ModelType } from '../../../libs/layouts/populateLayouts/types/models';
import { layoutModelToProps } from '../../../libs/layouts/utils/layoutModelToProps';
import type { WinStreakState } from '../WinStreakState';

const pathPosition = [
  { x: -74, deltaY: -139 },
  { x: 74, deltaY: -64 },
  { x: 74, deltaY: -139 },
  { x: -74, deltaY: -64 },
];

const chestOffset = {
  x: 160,
  y: 30,
};

function generatePathNodes(state: WinStreakState): WinStreakRoadMapData['pathNodes'] {
  let currentY = -200;

  const {
    lastOpenedChestIndex,
    config: { levels, chests },
  } = state;

  const lastOpenedChestLevel = chests[lastOpenedChestIndex]?.level ?? -1;

  return new Array(levels).fill(null).map((_, index) => {
    const nodeConfig = pathPosition[index % pathPosition.length];

    if (index > 0) currentY += nodeConfig.deltaY;

    return {
      checkMark: index <= lastOpenedChestLevel,
      x: nodeConfig.x,
      y: currentY,
    };
  });
}

function generateChests(
  state: WinStreakState,
  path: WinStreakRoadMapData['pathNodes'],
): WinStreakRoadMapData['chests'] {
  const {
    config: { chests },
  } = state;

  return chests
    .map((configData) => {
      const pathNode = path[configData.level];

      if (!pathNode) return null;

      return {
        x: pathNode.x + chestOffset.x * Math.sign(pathNode.x),
        y: pathNode.y + chestOffset.y,
        level: configData.level,
        rewards: configData.rewards,
      };
    })
    .filter(Boolean) as WinStreakRoadMapData['chests'];
}

function generateDecorations(state: WinStreakState): WinStreakRoadMapData['decorations'] {
  console.log('TODO: handle different decorations', state);
  return WinStreakStandardDecorationsLayout.raw.list
    .filter((model) => model.type === ModelType.Sprite)
    .map((model) => layoutModelToProps(model as unknown as AnyModel<never>));
}

export function generateWinStreakRoadData(state: WinStreakState): WinStreakRoadMapData {
  const pathNodes = generatePathNodes(state);

  return {
    pathNodes,
    chests: generateChests(state, pathNodes),
    decorations: generateDecorations(state),
  };
}
